<template>
  <div class="grid grid-cols-9 grid-rows-1">
    <div class="relative col-span-1 col-start-1 row-span-2 row-start-1 flex items-center justify-center md:col-start-5">
      <div class="pointer-events-none h-full w-0 border-l-4 border-dashed" />
      <div class="bg-peacock-500 absolute top-16 -mt-3 h-6 w-6 rounded-full border-4 border-white shadow-lg" />
    </div>

    <div
      v-if="$slots.left"
      class="col-span-8 col-start-2 py-6 md:col-span-4 md:col-start-1 md:row-start-1 md:py-12"
    >
      <slot name="left" />
    </div>
    <div
      v-if="$slots.right"
      class="col-span-8 col-start-2 py-6 md:col-span-4 md:col-start-6 md:row-start-1 md:py-12"
    >
      <slot name="right" />
    </div>
  </div>
</template>
